import Vue from 'vue'
import ContentItem from './components/ContentItem'

var travelInfo = new Vue({
  el: '#travelInfoAjaxAApp',
  components: {
    ContentItem,
  },
  data: {
    currentSlug: 'all',
    termListData: window.TERM_LIST_DATA,
    travelInfoData: window.TRAVEL_INFO_DATA,
    parentListItems: window.PARENT_LIST_ITEMS,
    childListItems: window.CHILD_LIST_ITEMS,
    travelInfoDisplay: [],
  },
  mounted() {
    this.travelInfoDisplay = this.travelInfoData;
    // console.log(this.termListData)
    // console.log(this.parentListItems)
    // console.log(this.travelInfoData)
  },
  methods: {
    handleChangeCategory: function(slug) {
      this.currentSlug = slug;
      // console.log('slug: ' + slug)
      if ( slug === 'all' ) {
        this.travelInfoDisplay = this.travelInfoData;
      }else{
        if(  Array.isArray(this.travelInfoData) ) {
          this.travelInfoDisplay = this.travelInfoData.filter(item => {
            return Array.isArray(item.post_terms) ? item.post_terms.find(term => term.slug === slug) : false
          }) 
          // console.log(this.travelInfoDisplay)
        }
      }
    }
  }
})